/**
 * TEN-2382: dev/prod isolation guard for URL resolution.
 *
 * The MCP server resolves its deployment URL from env vars only and falls back to
 * the hardcoded production gateway (DEFAULT_CLOUD_URL) when nothing is set. That
 * fall-through is silent today, so a misconfigured deployment quietly talks to
 * production. This makes it loud.
 *
 * Constraint (settled by review): the mcp-server has NO signal for "a repo-local
 * binding was expected" — it sees only env. So the warn fires on ANY fall-through
 * to the hardcoded default (Option A), not on an unimplementable "binding expected
 * but absent" condition.
 *
 * stderr ONLY — never stdout: stdio transport reserves stdout for MCP protocol bytes.
 */
import { DEFAULT_CLOUD_URL } from "./client.js";

/**
 * Warn (on stderr) when `resolved` is the hardcoded production gateway because no
 * deployment URL was set explicitly. No-op when a URL was configured, or when the
 * resolved URL is anything other than the hardcoded default.
 */
export function warnOnProdFallthrough(
  resolved: string,
  opts: { explicit: boolean },
): void {
  if (opts.explicit) return;
  if (resolved.replace(/\/$/, "") !== DEFAULT_CLOUD_URL.replace(/\/$/, "")) return;
  process.stderr.write(
    `[MCP] No deployment URL configured — defaulting to the production gateway ` +
      `${DEFAULT_CLOUD_URL}. Set CONVEX_SITE_URL or PRODUCTBRAIN_URL to target a ` +
      `different deployment.\n`,
  );
}
